import React from 'react';
import styled from 'styled-components';

import Link from '@/components/Link';
import CatalogCard from '@/components/Cards/CatalogCard';
import { ButtonLink } from '@/components/Button';
import { CatalogExtendedRelation } from '@/typings/model';

type Props = {
  data: CatalogExtendedRelation[];
};

function RelationsExtended({ data }: Props) {
  return (
    <Component>
      {data.map((item) => (
        <Wrapper key={item.id}>
          <SubCategory>{item.name}</SubCategory>
          {item.products.slice(0, 2).map((product) => (
            <Link key={product.id} to={`/products/${product.urlAlias}`}>
              <CatalogCard data={product} />
            </Link>
          ))}
          <StyledButton href={item.url} variant="outlined-primary-w100">
            {item.buttonLabel}
          </StyledButton>
        </Wrapper>
      ))}
    </Component>
  );
}

export default RelationsExtended;

const Component = styled.div``;

const SubCategory = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;
const Wrapper = styled.div<{ isForSpinner?: boolean }>`
  margin-top: 30px;

  display: grid;
  row-gap: 15px;
  position: relative;
  min-height: ${({ isForSpinner }) => (isForSpinner ? 352 : 100)}px;
`;

const StyledButton = styled(ButtonLink)``;
